import { compose, withHandlers, withStateHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import auth from 'dash-front/auth';
import config from 'cfg';
import _ from 'lodash';
import moment from 'moment';

export const withEditorWidget = compose(
    connect(({ editor }) => ({
        widgetId: editor.widgetId,
        widgetProps: editor.widgetProps,
        template: editor.template,
        disabled: !editor.preview,
        zoom: editor.zoom,
    })),
    withHandlers({
        onClick: ({ widgetId, widgetProps, template, ...props }) => event => {
            props.onClick(event, { widgetId, widgetProps }, template);
        },
    }),
);

export const withUserImages = compose(
    withStateHandlers(
        {
            data: [],
            images: [],
            offset: 0,
            limit: 10,
            rev: 0,
        },
        {
            onImages: ({ offset, limit }) => data => ({
                data,
                images: _.chain(data)
                    .orderBy(i => -moment(i.createdAt))
                    .take(limit)
                    .value(),
            }),
            next: ({ offset, limit, data }) => () => ({
                images: _.chain(data)
                    .orderBy(i => -moment(i.createdAt))
                    .slice(offset + limit)
                    .take(limit)
                    .value(),
                offset: offset + limit,
            }),
            prev: ({ offset, limit, data }) => () => ({
                offset: Math.max(offset - limit, 0),
                images: _.chain(data)
                    .orderBy(i => -moment(i.createdAt))
                    .slice(offset - limit)
                    .take(limit)
                    .value(),
            }),
            doRefreshImages: ({ rev }) => () => ({
                rev: rev + 1,
                offset: 0,
            }),
        },
    ),
    lifecycle({
        componentWillReceiveProps(nextProps) {
            if (nextProps.rev != this.props.rev) {
                fetch(`${config.dash.api.host}/api/media?access_token=${auth.getAccessToken()}`)
                    .then(response => response.json())
                    .then(data => {
                        this.props.onImages(data);
                    });
            }
        },
        componentDidMount() {
            fetch(`${config.dash.api.host}/api/media?access_token=${auth.getAccessToken()}`)
                .then(response => response.json())
                .then(data => {
                    this.props.onImages(data);
                });
        },
    }),
);



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/hoc/editor.js
 **/